import { render, staticRenderFns } from "./WorldCat.vue?vue&type=template&id=8f2f0dd8&"
import script from "./WorldCat.vue?vue&type=script&lang=js&"
export * from "./WorldCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f2f0dd8')) {
      api.createRecord('8f2f0dd8', component.options)
    } else {
      api.reload('8f2f0dd8', component.options)
    }
    module.hot.accept("./WorldCat.vue?vue&type=template&id=8f2f0dd8&", function () {
      api.rerender('8f2f0dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorldCat.vue"
export default component.exports